import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    RouterProvider,
    Navigate,
} from 'react-router-dom';

import Plausible from 'plausible-tracker';
import ErrorPage from './src/ErrorPage.jsx';
import { Root } from './src/Root.tsx';
import { Page } from './src/Page.tsx';
import Register from './src/Register.tsx';
import { checkForReferrer, checkForSource } from './src/utils/appFunctions.ts';

window.process = process;

const { enableAutoPageviews } = Plausible()
enableAutoPageviews()

const router = createBrowserRouter([
    {
        path: "/build",
        element : <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true, // Matches `/build`
                element: (
                    <>
                        <Navigate to="page/intro" replace />
                    </>
                )
            },
            {
                path: "page/:pageId",
                element: <Page />,
            }
        ]
    },
    {
        path: "/build/register",
        element: <Register />,
    },
    {
        path: "*", // This will match all routes that aren't defined above
        element: <ErrorPage />, // Custom error page for any undefined route
    }
]);

document.addEventListener('DOMContentLoaded', function() {      
    checkForReferrer();
    checkForSource();

    const root = ReactDOM.createRoot(document.getElementById('enquiryapp'));

    root.render(
        <React.StrictMode>
            <RouterProvider router={router} />
        </React.StrictMode>
    );
});